import { useState } from "react";
import type { AttachedDocumentListItem } from "../types";

export interface PromptState {
  title: string;
  text: string;
  variant: "success" | "error";
}

export function useAttachedDocumentsModals() {
  const [createModal, setCreateModal] = useState(false);
  const [editModal, setEditModal] = useState<AttachedDocumentListItem | null>(null);
  const [detailModal, setDetailModal] = useState<AttachedDocumentListItem | null>(null);
  const [confirmDelete, setConfirmDelete] = useState<number | null>(null);
  const [prompt, setPrompt] = useState<PromptState | null>(null);

  return {
    createModal,
    setCreateModal,
    editModal,
    setEditModal,
    detailModal,
    setDetailModal,
    confirmDelete,
    setConfirmDelete,
    prompt,
    setPrompt,
  };
}
